import { ComponentProps, FC } from 'react';
import Script from 'next/script';
import { getConfig } from '@belong/configs/next/config';
import { logger } from '@belong/logging/logger';

interface IScriptProps {
  scriptName: string;
  strategy?: ComponentProps<typeof Script>['strategy'];
}

export const PlatformScript: FC = () => {
  return (
    <Script
      dangerouslySetInnerHTML={{
        __html: `document.querySelector('html').setAttribute('data-platform', navigator.platform);`
      }}
      strategy="afterInteractive"
    />
  );
};

PlatformScript.displayName = 'PlatformScript';

export const PolyfillScript: FC<IScriptProps> = ({ scriptName, strategy = 'afterInteractive' }) => {
  const { basePath } = getConfig().publicRuntimeConfig;
  return (
    <>
      <Script
        src={`${basePath}/static/polyfills/${scriptName}`}
        strategy={strategy}
        onError={() => {
          logger.error(
            `${scriptName} doesn't exist in this app. If you want to use it you must place it in the static/polyfills directory`
          );
        }}
      />
    </>
  );
};

PolyfillScript.displayName = 'PolyfillScript';
